module.exports = __webpack_public_path__ + "img/16.adc3b8ac.png";